jQuery(document).ready(function($) {
    $('.faqItem__question').on('click', function() {
        var origin = $(this).parent();

        if (origin.hasClass('faqItem--active')) {
            origin.removeClass('faqItem--active');
            origin.find('.faqItem__answer').slideUp();
        } else {
            $('.faqItem--active').find('.faqItem__answer').slideUp();
            $('.faqItem--active').removeClass('faqItem--active');

            origin.addClass('faqItem--active');
            origin.find('.faqItem__answer').slideDown();
        }
    });

    $('.pdpDescription__accordionButton').on('click', function() {
        var origin = $(this).parent();

        if (!origin.hasClass('pdpDescription__accordion--active')) {
            origin.addClass('pdpDescription__accordion--active');
            origin.find('.pdpDescription__accordionContent').slideDown();
        }
    });

    if ($('.faqCategory').length > 0){
        var categoryList = [];
        var handleList = [];
        $('.faqCategory').each(function(){
            categoryList.push($(this).data('category'));
            handleList.push($(this).data('category-name'));
        });

        var categoryButtonTemplate = $('.faqPage__filterButton--template').clone();
        $('.faqPage__filterRow').empty();
        categoryButtonTemplate.removeClass('faqPage__filterButton--template');
        categoryButtonTemplate.find('.faqPage__filterButtonText').text('All');
        categoryButtonTemplate.data('filter', 'all');
        categoryButtonTemplate.appendTo('.faqPage__filterRow');

        for (var i = 0; i < categoryList.length; i++){
            var categoryButton = categoryButtonTemplate.clone();
            categoryButton.removeClass('faqPage__filterButton--template');
            categoryButton.find('.faqPage__filterButtonText').text(handleList[i]);
            categoryButton.data('filter', categoryList[i]);
            categoryButton.appendTo('.faqPage__filterRow');
        }
    }

    var filterQuery = 'all';
    //check for ?filter= in the url, make sure it does not grab other query string content
    if (window.location.search.includes('filter=')){
        filterQuery = window.location.search.split('filter=')[1].split('&')[0];
    }

    $('.faqPage__filterButton').each(function(){
        if ($(this).data('filter') == filterQuery){
            $(this).addClass('faqPage__filterButton--active');
        }
    });

    $('.faqPage__filterButton').on('click', function(){
        var filter = $(this).data('filter');

        var url = new URL(window.location.href);
        
        url.searchParams.set('filter', filter);
        window.history.pushState({}, '', url.toString());
        // Update active state on buttons
        $('.faqPage__filterButton').removeClass('faqPage__filterButton--active');
        $(this).addClass('faqPage__filterButton--active');
        filterFaqItems(filter);
    });

    function filterFaqItems(filter){
        if (filter == 'all'){
            $('.faqCategory').show();
        } else {
            $('.faqCategory').hide();
            $('.faqCategory[data-category="' + filter + '"]').show();
        }
    }

    filterFaqItems(filterQuery);
});